import { useFetch } from '#imports'
import ssrReqHeader from '@/utils/ssrReqHeader'
import { type GetShareQuery } from '~/api/index'
import { removeUrlKeyFromFiles } from '~/store/share.script'
import { ShareStatus } from '~/types/enum'
import { DRIVE_API_V1 } from './common'

// 本地环境用线上接口， 否则用微服务
const SSR_PP_DRIVE_API = process.dev ? DRIVE_API_V1 : 'http://drive:80/drive/v1'

interface ShareFileListRes {
  share_status: ShareStatus
  files: PPFile[]
  next_page_token: string
}

/** 获取分享详情信息 */
export const fetchShareResData = async (query: GetShareQuery): Promise<Share | null> =>
  import.meta.server
    ? (
        await useFetch<Share>(`${SSR_PP_DRIVE_API}/share`, {
          query,
          headers: ssrReqHeader(),
          transform: removeUrlKeyFromFiles, // 移除文件URL中的敏感key参数
        })
      ).data.value
    : null

/** 获取当前分享文件的所有祖先文件夹信息 */
export const getBatchFileInfo = async (body: { share_id: string; file_ids: string[]; pass_code_token: string }) =>
  useFetch<{
    share_status: ShareStatus
    files: PPFile[]
  }>(`${SSR_PP_DRIVE_API}/share:batch_file_info`, {
    method: 'POST',
    headers: ssrReqHeader(),
    body,
  })

/** 获取分享文件列表 */
export const getShareFileList = async (query: GetShareQuery & { parent_id?: string }) =>
  useFetch<ShareFileListRes>(`${SSR_PP_DRIVE_API}/share/detail`, {
    query,
    headers: ssrReqHeader(),
    transform: removeUrlKeyFromFiles, // 移除文件URL中的敏感key参数
  })
